import { render, staticRenderFns } from "./SaveBuildingSchedule.vue?vue&type=template&id=bbc285f2&scoped=true"
import script from "./SaveBuildingSchedule.vue?vue&type=script&lang=js"
export * from "./SaveBuildingSchedule.vue?vue&type=script&lang=js"
import style0 from "./SaveBuildingSchedule.vue?vue&type=style&index=0&id=bbc285f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc285f2",
  null
  
)

export default component.exports